module.exports = __webpack_public_path__ + "static/kol2.ecf962e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/data/screenshots/spindal/kol2.jpg
// module id = ./src/app/data/screenshots/spindal/kol2.jpg
// module chunks = 9